'use client';

import { __awaiter, __generator } from '../../../_virtual/_tslib.js';
import React__default, { useContext, useState, useRef, useEffect } from 'react';
import Input from '../../../Input/index.js';
import { getSearchJob } from '../../apiServices.js';
import { DEFAULT_MAX_LENGTH_INPUT, KEYCODE, RETRIEVE_FIELDS_SEARCH } from '../../constants.js';
import { ACTIONS } from '../../context/actions.js';
import { SearchBarContext } from '../../context/reducer.js';
import { getLocalStorage } from '../../searchbarHelpers.js';
import { EForceControDropdown } from '../../context/types.js';

var SearchInput = function () {
    var _a;
    var _b = useContext(SearchBarContext), state = _b.state, dispatch = _b.dispatch, t = _b.t, props = _b.props, search = _b.search;
    var keyword = state.keyword, isShow = state.isShow, selectedSuggestionIndex = state.selectedSuggestionIndex, suggestions = state.suggestions;
    var pageName = props.pageName, msBaseUrl = props.msBaseUrl, searchBarOptions = props.searchBarOptions, isMobile = props.isMobile;
    var _c = useState(t('Search for jobs, companies, skills')), placeholderText = _c[0], setPlaceholderText = _c[1];
    var timer = useRef();
    var inputRef = useRef(null);
    var doGetSearchTopJob = function (locationList) { return __awaiter(void 0, void 0, void 0, function () {
        var filter, postData, searchTopJob, topJobItem;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (keyword.length === 0) {
                        return [2 /*return*/, false];
                    }
                    filter = [];
                    if (locationList.length > 0) {
                        filter.push({
                            field: 'workingLocations.cityId',
                            value: (_a = locationList === null || locationList === void 0 ? void 0 : locationList.map(function (item) { return item.parentId; })) === null || _a === void 0 ? void 0 : _a.join(',')
                        });
                    }
                    postData = {
                        query: keyword,
                        filter: filter,
                        ranges: [],
                        order: [],
                        hitsPerPage: 1,
                        page: 0,
                        retrieveFields: RETRIEVE_FIELDS_SEARCH
                    };
                    return [4 /*yield*/, getSearchJob(msBaseUrl, postData)];
                case 1:
                    searchTopJob = _c.sent();
                    topJobItem = null;
                    if (((_b = searchTopJob === null || searchTopJob === void 0 ? void 0 : searchTopJob.data) === null || _b === void 0 ? void 0 : _b.length) > 0 && searchTopJob.data[0].priorityOrder !== '1970-01-01T07:00:00') {
                        topJobItem = searchTopJob.data[0];
                    }
                    if (topJobItem !== null) {
                        dispatch({
                            type: ACTIONS.SET_TOP_JOB_ITEM,
                            payload: topJobItem
                        });
                    }
                    return [2 /*return*/, true];
            }
        });
    }); };
    var onInputChange = function (keyword) {
        var _a;
        dispatch({
            type: ACTIONS.SET_KEYWORD,
            payload: keyword
        });
        dispatch({
            type: ACTIONS.SET_TOP_JOB_ITEM,
            payload: null
        });
        if (keyword.length <= 0) {
            return;
        }
        var lastCharacterOfKeyword = keyword.substring(keyword.length - 1);
        if (lastCharacterOfKeyword !== ' ') {
            return;
        }
        var localParams = getLocalStorage('params', '');
        doGetSearchTopJob((_a = localParams === null || localParams === void 0 ? void 0 : localParams.locations) !== null && _a !== void 0 ? _a : []);
    };
    var onInputKeydown = function (e) {
        var _a, _b;
        switch (e.key) {
            case KEYCODE.ENTER:
                search();
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                dispatch({
                    type: ACTIONS.CLOSE_DROP_DOWN
                });
                break;
            case KEYCODE.ESCAPE:
                (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.blur();
                dispatch({
                    type: ACTIONS.CLOSE_DROP_DOWN
                });
                break;
            case KEYCODE.ARROW_UP:
                {
                    if (suggestions.length === 0) {
                        return;
                    }
                    e.preventDefault();
                    var maxIndex = suggestions.length - 1;
                    var nextIndex = selectedSuggestionIndex - 1;
                    if (nextIndex < 0) {
                        nextIndex = maxIndex;
                    }
                    dispatch({
                        type: ACTIONS.UPDATE_SELECTED_SUGGESTION_INDEX,
                        payload: nextIndex
                    });
                }
                break;
            case KEYCODE.ARROW_DOWN:
                {
                    if (suggestions.length === 0) {
                        return;
                    }
                    e.preventDefault();
                    var maxIndex = suggestions.length - 1;
                    var nextIndex = selectedSuggestionIndex + 1;
                    if (nextIndex > maxIndex) {
                        nextIndex = 0;
                    }
                    dispatch({
                        type: ACTIONS.UPDATE_SELECTED_SUGGESTION_INDEX,
                        payload: nextIndex
                    });
                }
                break;
            default:
                {
                    // Release locked debounce
                    dispatch({
                        type: ACTIONS.TOGGLE_LOCK_DEBOUNCE,
                        payload: false
                    });
                }
                break;
        }
    };
    var onInputFocus = function () {
        if (isShow) {
            return;
        }
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(function () {
            dispatch({
                type: ACTIONS.FORCE_CONTROL,
                payload: EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT
            });
        }, 250);
    };
    var onTouchMove = function (e) {
        var _a;
        if (!isMobile) {
            return;
        }
        // Blur input when user scrolling out
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    };
    useEffect(function () {
        var _a;
        if (isShow) {
            return;
        }
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    }, [isShow]);
    useEffect(function () {
        var newPlaceholderText = placeholderText;
        if (pageName === 'interview') {
            newPlaceholderText = t('Enter a job title to view a set of interview questions');
        }
        else if (pageName === 'salary') {
            newPlaceholderText = t('Enter a job title to view salary');
        }
        // Special breakpoint for place holder
        var isInMobile = typeof window !== 'undefined' ? window.innerWidth <= 1024 : false;
        if (isInMobile) {
            newPlaceholderText = t('Search');
        }
        setPlaceholderText(newPlaceholderText);
    }, [pageName]);
    useEffect(function () {
        window.addEventListener('touchmove', onTouchMove, { passive: false });
        return function () {
            window.removeEventListener('touchmove', onTouchMove);
        };
    }, []);
    return (React__default.createElement(Input, { value: keyword, onChange: onInputChange, onKeyDown: onInputKeydown, placeholder: placeholderText, autoComplete: 'off', maxLength: (_a = searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.maxInputLength) !== null && _a !== void 0 ? _a : DEFAULT_MAX_LENGTH_INPUT, onFocus: onInputFocus, inputRef: inputRef, enterKeyHint: 'search' }));
};

export { SearchInput as default };
//# sourceMappingURL=index.js.map
